import { render, staticRenderFns } from "./ReportCustomerGriffinMktzap.vue?vue&type=template&id=10c1a994"
import script from "./ReportCustomerGriffinMktzap.vue?vue&type=script&lang=js"
export * from "./ReportCustomerGriffinMktzap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports